function productCartFunctions() {
    const moreColorsButtons = document.querySelectorAll(".more_colors");

    moreColorsButtons?.forEach(button => {
      const parent = button.closest(".color-swatch-options"); 
      
      button.addEventListener("click", function() {
        const hiddenColors = parent.querySelectorAll(`.hidden-color`);
        hiddenColors.forEach(color => {
          color.classList.remove('hidden-color');
        });
        button.style.display = 'none';
        document.dispatchEvent(new CustomEvent('articleSliderInit:init'))
        
      });
    });
  
    const cardProductImageSlidersTwo = document.querySelectorAll('.card_product_images_mobile:not(.flickity-enabled)');
    cardProductImageSlidersTwo?.forEach((cardProductImageSlider) => {
      requestAnimationFrame(() => {
        new Flickity(cardProductImageSlider, {
          wrapAround: true,
          percentPosition: false,
          pageDots: true,
          cellAlign: "left",
          imagesLoaded: true,
          freeScroll: false,
          contain: true,
          on: {
            ready() {
              const cardimages = cardProductImageSlider.querySelectorAll('img');
              cardimages.forEach((img) => img.classList.remove('image_hidden'));
            }
          }
        });
      });
    });
    
    const initFlickity = (cardMedia) => {
    requestAnimationFrame(() => {
      new Flickity(cardMedia, {
        wrapAround: true,
        percentPosition: false,
        pageDots: true,
        cellAlign: "left",
        imagesLoaded: true,
        freeScroll: false,
        contain: true,
        on: {
          ready() {
            const cardimages = cardMedia.querySelectorAll('img');
            cardimages.forEach((img) => img.classList.remove('image_hidden'));
          }
        }
      });
    });
  };
  
    document.querySelectorAll('.custom-color-swatch ul')?.forEach((ul, index) => {
        ul.setAttribute('data-id', `custom-id-${index + 1}`); // Create a custom data-id
        
        let lastHoveredItem = null;
        let flickityInstance = null; // Keep track of the Flickity instance
  
        // Function to handle the swatch activation
        const activateSwatch = (item) => {
            ul.querySelectorAll('li').forEach((sibling) => {
                if (sibling !== item) {
                    sibling.classList.remove('active-color');
                }
            });
  
            if (lastHoveredItem && lastHoveredItem !== item) {
                lastHoveredItem.classList.remove('active-color');
            }
  
            item.classList.add('active-color');
            lastHoveredItem = item; // Update the last hovered item
  
            // Get inner HTML of the relevant div inside li based on window width
            const imageDiv = item.querySelector(window.innerWidth <= 767 ? '.mobile_swatchss' : '.desktop_swatchss');
            const imageHTML = imageDiv ? imageDiv.innerHTML : ''; 
  
            // Determine the appropriate selector for card media based on window width
            const cardMedia = item.closest('.card').querySelector(
                window.innerWidth <= 767
                    ? '.card__inner .card_product_images_mobile'
                    : '.card__inner .card__media .media'
            );
  
            if (cardMedia) {
                // Check if cardMedia has Flickity initialized (flickity-enabled class)
                if (cardMedia.classList.contains('flickity-enabled')) {
                    // Destroy the Flickity instance if it exists
                    flickityInstance = Flickity.data(cardMedia);  // Get the current Flickity instance
                    if (flickityInstance) {
                        flickityInstance.destroy();  // Destroy the current Flickity instance
                        flickityInstance = null;  // Reset the instance
                        cardMedia.classList.remove('flickity-enabled');  // Remove the class
                    }
                }
  
                cardMedia.innerHTML = imageHTML; // Replace card media content with image HTML
                // Reinitialize Flickity for mobile view
                if (window.innerWidth <= 767) {
                    flickityInstance = initFlickity(cardMedia); // Initialize Flickity again
                }
            }
        };
  
        ul.querySelectorAll('li').forEach((item) => {
            item.addEventListener('mouseenter', () => activateSwatch(item));
  
            // Add touchstart event for mobile devices
            item.addEventListener('touchstart', (e) => {
                e.preventDefault(); // Prevent scrolling when tapping
                activateSwatch(item);
            });
        });
  
        ul.addEventListener('mouseleave', () => {
            if (lastHoveredItem) {
                lastHoveredItem.classList.add('active-color'); // Keep the active-color
            }
        });
    });
}

document.addEventListener("DOMContentLoaded",()=>{
  productCartFunctions();
});

document.addEventListener('productCartFunctions:init', productCartFunctions);